import { get } from '../../../redux/api';
import type { CurrentUser } from '../../../../shared/types/routes/publicPortal/users';

export const getCurrentUser = () => get<CurrentUser>('/api/users/me');
